import React, { useEffect, useState } from 'react';
import { AppRouter } from './app/modules/routing/app-router';
import { StorageService } from './app/modules/shared/logic/storage-service';
import { MouseEmphasize } from './app/modules/shared/components/mouse-emphasize/mouse-emphasize';
import './App.scss';

const App: React.FC = () => {
	const [storageService] = useState(StorageService.getInstance());
	useEffect(() => () => storageService.clear());

	return (
		<div className={'app'} style={{ position: 'relative' }}>
			<MouseEmphasize>
				<AppRouter/>
			</MouseEmphasize>
		</div>
	);
};

export default App;
